import { responses } from "@/mocks/scandal";

const icons = ["ri-user-voice-line", "ri-building-2-line", "ri-shopping-cart-line", "ri-video-line"];

export default function Responses() {
  return (
    <section id="response" className="border-b border-background-200/70 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="inline-block h-4 w-1.5 rounded-sm bg-accent-500" />
              <span className="text-xs font-bold uppercase tracking-widest text-accent-600">Statements & Responses</span>
            </div>
            <h2 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-3xl">
              当事人与相关方动态
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              谁的声明、谁在跟进、回应到什么程度——按角色归档，方便对照主时间线一起读。
            </p>
          </div>
          <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-800 whitespace-nowrap">
            <i className="ri-verified-badge-line" /> 声明全文已收录
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {responses.map((r, i) => (
            <article
              key={r.actor}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300"
            >
              <div className="flex items-start justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${icons[i % icons.length]} text-lg`} />
                </span>
                <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-bold ${r.tone}`}>{r.role}</span>
              </div>
              <h3 className="mt-4 text-[15px] font-bold text-foreground-900">{r.actor}</h3>
              <p className="mt-1 text-xs font-semibold text-primary-600">{r.status}</p>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{r.text}</p>
              <div className="mt-4 flex items-center gap-1.5 text-[11px] text-foreground-400">
                <i className="ri-time-line" />
                {r.time}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}